import React, { Component } from "react";
import AddTeamMember from "./AddTeamMember";
import AuthorsTable from "./AuthorsTable";
import consumer from "../../../channels/consumer";
import CookieValue from "../../../utils/cookie_value";
import CoreIssue from "./CoreIssue";
// import CoreConcepts from './CoreConcepts';
import Counter from "../../../utils/counter";
import CourseCode from "./CourseCode";
import CourseDesc from "./CourseDesc";
import CourseName from "./CourseName";
import CreditHours from "./CreditHours";
import CoursePlc from "./CoursePlc";
// import CourseLos from './CourseLos';
import EnglishRoutine from "./EnglishRoutine";
import ErrorBoundary from "../../ErrorBoundary";
import FetchResource from "../../../utils/fetch_resource";
import GrandChallenges from "./GrandChallenges";
import InstructorInfo from "./InstructorInfo";
// import MatrixAssmt from './MatrixAssmt';
import ProgressBar from "../ProgressBar";
import SectionWithAdd from "./SectionWithAdd";
import Spinner from "../../Spinner";
import StatefulAssessments from "./StatefulAssessments";
import StatefulConcepts from "./StatefulConcepts";
import StatefulModules from "./StatefulModules";
import StatefulRichTextSection from "./StatefulRichTextSection";
import StatefulSimpleSection from "./StatefulSimpleSection";
import StatusBox from "./StatusBox";
import TeachHrs from "./TeachHrs";
import StatefulWeeklyPlan from "./StatefulWeeklyPlan";
import logoUsaid from "../../../../assets/logoUsaid.png";

const api_base = process.env.API_URL;
const log_to_console = !(
  process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "production"
);

export default class SyllabiShowMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.syllabusId,
      course_name: null,
      plc_link: "",
      course_code_a: ",,,,",
      eng_routine_lookup_id: null,
      is_exemplar: null,
      credit_hours: null,
      subject_lookup_id: 0,
      course_description_locales: { en: "", ar_EG: "" },
      core_issue: "",
      grand_challenge_options: [],
      users: [],
      // syl_big_ideas: [],
      main_los: [],
      suggested_emails: [],
      syl_core_concepts: {},
      // syl_standards: [],
      // syl_req_readings: [],
      syl_matrix_assmts: [],
      subject_options: [],
      rr_options: [],
      assmt_type_options: [],
      assmt_matrix_points: [],
      syl_grand_challenges: [],
      // syl_equip_materials: [],
      units: [],
      unit_child_options: [],
      al_coursework: 0,
      lab_field: 0,
      edit_mode: false,
      connected: false,
      last_req_millisecond: 0,
      key_in_focus: null,
      author_to_add: null,
      found_author: false,
      author_email_search: "",
      userRole: props.userRole,
      userId: props.userId,
      data_ready: false,
      display_error: false,
      permissions: { read: false, update: false, assign_authors: false },
      progress_a: "0,0,0,0,0,0,0,0,0,0,0,0",
      container_id: Date.now(), //TODO: make this reliably unique. Used to determine if tab should be updated from actioncable broadcast
      timer: null,
      cable_consumer: null,
      weeks: [],
      lastUpdateType: null, //set when subscription receives data
      updateTime: Date.now(),
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.subscribe();
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    if (this.state.cable_consumer != null) {
      /**
       * equivalent of closing the tab with the
       * connection.
       * On the backend, not only is unsubscribe called
       * for the channel, but the consumer connection
       * itself is closed and will no longer appear in
       * the connection.server.connections array in ActionCable::Channel.
       **/
      this.state.cable_consumer.disconnect();
    }
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this._isMounted) {
      let key = this.state.key_in_focus;
      if (key != null) {
        const elem = document.getElementById(key + "input");
        if (!!elem) elem.focus();
      }
      /**no longer used?**/
      if (this.props !== prevProps) {
        // console.log('update state!')
        this.setState({
          userRole: this.props.userRole,
          userId: this.props.userId,
        });
      }
    }
  };

  fetchSyllabus = () => {
    /**
     * Initialize units and main_los in the main container once.
     * These two lists are passed to multiple child components
     * when they initially render. However, subsequent state
     * updates are handled by the stateful child components.
     **/
    this.fetchMainLos();
    this.fetchUnits();
    return FetchResource(api_base + "syllabi/" + this.state.id, "", this);
  };

  fetchUnits = () => {
    this.apiCall(
      `${api_base}units?unit[syllabus_id]=${this.state.id}`,
      this.reqOptions("GET"),
      false /** Don't do the default state update for this container **/,
      (data) => this.setState({ units: data }) /** custom state update **/
    );
  };

  fetchMainLos = () => {
    this.apiCall(
      `${api_base}main_los?main_lo[syllabus_id]=${this.state.id}`,
      this.reqOptions("GET"),
      false /** Don't do the default state update for this container **/,
      (data) => this.setState({ main_los: data }) /** custom state update **/
    );
  };

  debounce = (fn, delay) => {
    if (this.state.timer) clearTimeout(this.state.timer);
    let timer = setTimeout(() => {
      fn();
    }, delay);
    // console.log('timer:', timer)
    if (this._isMounted) {
      this.setState({ timer: timer });
    }
  };

  /**
   * Return a map of user arrays by university type (e.g., by US University and Egyptian University)
   * {eguniv: [user1, user2, ...], usuniv: [user10, user11, ...]}
   **/
  mapUsersToTeam = (users) => {
    return users.reduce((r, user) => {
      if (user.university) {
        r[user.university.type] = [...(r[user.university.type] || []), user];
      }
      return r;
    }, {});
  };

  addItem = (options, e) => {
    let {
      type,
      plType,
      type_lookup_id,
      sequence,
      subject_lookup_id,
      field,
      value,
      unit_id,
    } = options;
    const url = api_base + (plType || type + "s");
    let body = { syllabus_id: this.state.id };
    body[type] = { syllabus_id: this.state.id };
    if (type_lookup_id) {
      body[type]["type_lookup_id"] = type_lookup_id;
    }
    if (sequence) {
      body[type]["sequence"] = sequence;
    }
    if (subject_lookup_id) {
      body[type]["subject_lookup_id"] = subject_lookup_id;
    }
    if (unit_id) {
      body[type]["unit_id"] = unit_id;
    }
    if (field) {
      body[type][field] = value;
    }
    this.apiCall(url, this.reqOptions("POST", body), true);
  };

  addUnitItem = (options, e) => {
    let { plType, singularType, unitId, mainLoId } = options;
    const url = api_base + plType;
    let body = {};
    body[singularType] = { syllabus_id: this.state.id };
    if (unitId) {
      body[singularType]["unit_id"] = unitId;
    }
    if (mainLoId) {
      body[singularType]["main_lo_id"] = mainLoId;
    }
    this.apiCall(url, this.reqOptions("POST", body), true);
  };

  removeItem = (options) => {
    if (
      options["skipConfirm"] ||
      window.confirm("Are you sure you want to delete this item?")
    ) {
      let { type, singularType, plType, id, unitId } = options;
      const url = api_base + (plType || type + "s") + "/" + id;
      let body = { syllabus_id: this.state.id };
      if (type === "main_los_unit") {
        // body['syllabus_id'] = this.state.id;
        body[type] = { unit_id: unitId, main_lo_id: id, active: false };
      } else if (type === "main_los_reading") {
        // body['syllabus_id'] = this.state.id;
        body[type] = {
          unit_id: unitId,
          main_los_reading_id: id,
          active: false,
        };
      } else {
        body[singularType || type] = {
          syllabus_id: this.state.id,
          active: false,
        };
      }
      this.unfocus();
      this.apiCall(url, this.reqOptions("PATCH", body), true);
    }
  };

  updateCourseCode = (options, event) => {
    const { keyStr, keyNum } = options;
    let ccode = this.state.course_code_a.split(",");
    ccode[keyNum] = event.target.value;
    this.updateSyllabus(
      {
        ccode: ccode.join(","),
        type: "course_code_a",
      },
      event
    );
    this.focus(keyStr + "-" + (parseInt(keyNum) + 1), null);
  };

  toggleProgressA = (ix, event) => {
    let progA = this.state.progress_a.split(",");
    progA[ix] = progA[ix] == "1" ? "0" : "1";
    this.updateSyllabus(
      {
        prog_a: progA.join(","),
        type: "progress_a",
      },
      event
    );
  };

  updateSyllabus = (options, event) => {
    let { type, ccode, prog_a, locale, assoc } = options;
    console.log("TYPE:", type);
    let url = api_base + "syllabi/" + this.state.id;
    let state = { last_req_millisecond: Date.now() };
    if (type == "course_description") {
      state = this.state.course_description_locales;
      state[locale] = event.target.value;
    } else {
      state[type] = ccode || prog_a || event.target.value;
    }
    if (this._isMounted) {
      this.setState(state);
      let sylContainer = this;
      this.debounce(() => {
        let body = {
          checkReqTimestamp: true,
          syllabus: {},
          container_id: sylContainer.state.container_id,
        };
        if (locale) {
          body["locale"] = locale;
          body["syllabus"][type] =
            sylContainer.state.course_description_locales[locale];
        } else {
          if (assoc) body[assoc] = {};
          //TODO: check if this will be a scoping issue.
          body[assoc || "syllabus"][type] =
            ccode || prog_a || sylContainer.state[type];
        }
        body["syllabus"]["last_req_millisecond"] = Date.now();
        sylContainer.apiCall(url, sylContainer.reqOptions("PATCH", body));
      }, 300);
    } //this._isMounted
  };

  updateWeeksJoins = (opts, event) => {
    //Safe to persist the event here, because all events will be from regular input/button elements
    console.log(opts);

    event.persist();
    const { selectId, joinId, scheduleableId, scheduleableType, week, active } =
      opts;
    if (this._isMounted) {
      const url = api_base + "weeks/" + week.id;
      const sylContainer = this;
      const weeks_join_attributes = {};
      if (active) {
        weeks_join_attributes["scheduleable_id"] =
          scheduleableId || $(`#${selectId}`).val();
        weeks_join_attributes["scheduleable_type"] = scheduleableType;
      } else {
        weeks_join_attributes["id"] = joinId;
        weeks_join_attributes["_destroy"] = 1;
      }
      this.debounce(() => {
        const body = {
          container_id: sylContainer.state.container_id,
          syllabus_id: sylContainer.state.id,
          week: {
            syllabus_id: sylContainer.state.id,
            weeks_joins_attributes: [weeks_join_attributes],
          },
        };
        sylContainer.apiCall(url, sylContainer.reqOptions("PATCH", body), true);
      }, 300);
    } //this._isMounted
  };

  // updateMatrixPoints = (opts, event) => {
  //   const {type, index, field} = opts;
  //   const  url = api_base + 'syllabi/' + this.state.id;
  //   let state = this.state;
  //   state[field][index] = event.target.value;
  //   let body = {
  //     syllabus: {'assmt_matrix_points_arr': state[field].join(',')},
  //     container_id: this.state.container_id
  //   };
  //   this.setState(state);
  //   this.apiCall(url, this.reqOptions('PATCH', body));
  // }

  updateItem = (options, event) => {
    // console.log(options)
    let { type, plType, id, index, field, updateStateAfterReq } = options;
    if (type === "syllabi") {
      this.updateMatrixPoints(options, event);
    } else {
      let state = this.state;
      if (field === "date") {
        // console.log('format date', this.formatDate(event.target.value))
        state[plType || type + "s"][index][field] = this.formatDate(
          event.target.value
        );
      } else {
        // console.log('updating', field)
        state[plType || type + "s"][index][field || "description"] =
          event.target.value;
      }
      if (this._isMounted && !updateStateAfterReq) {
        this.setState(state);
      }
    }
    let sylContainer = this;
    this.debounce(() => {
      if (type != "syllabi") {
        let body = {
          container_id: sylContainer.state.container_id,
          syllabus_id: sylContainer.state.id,
        };
        let url = api_base + (plType || type + "s") + "/" + id;
        body[type] = { syllabus_id: sylContainer.state.id };
        if (field === "date") {
          body[type][field || "description"] =
            sylContainer.state[plType || type + "s"][index][field][
              "inputVersion"
            ];
        } else {
          body[type][field || "description"] =
            sylContainer.state[plType || type + "s"][index][
              field || "description"
            ];
        }
        sylContainer.apiCall(
          url,
          sylContainer.reqOptions("PATCH", body),
          updateStateAfterReq
        );
      }
    }, 300);
  };

  updateInHash = (options, event) => {
    const {
      type,
      plType,
      id,
      key,
      index,
      unitIx,
      field,
      value,
      updateStateAfterReq,
    } = options;
    const state = this.state;
    let hash;
    if (unitIx != null) {
      hash = state["units"][unitIx]["descendants_by_type"];
    } else {
      hash = state[plType];
    }
    const item = hash[key || 0][index];
    item[field || "description"] = value || event.target.value;
    if (this._isMounted) {
      this.setState(state);
    }
    let sylContainer = this;
    this.debounce(() => {
      let body = { container_id: sylContainer.state.container_id };
      let url = api_base + plType + "/" + id;
      body[type] = { syllabus_id: sylContainer.state.id };
      body[type][field || "description"] = item[field || "description"];
      sylContainer.apiCall(
        url,
        sylContainer.reqOptions("PATCH", body),
        updateStateAfterReq
      );
    }, 300);
  };

  formatDate = (date) => {
    //generate the Date with the date string in
    //yyyy/mm/dd format, or the date will be one day off.
    const d = new Date(date.replace(/-/g, "/"));
    const opts = { month: "short", day: "numeric" };
    return {
      dateVersion: d.toLocaleDateString("en-US", opts),
      inputVersion: date,
    };
  };

  searchUsers = (opts, event) => {
    const { email } = opts;
    const url =
      api_base +
      "users/search?syllabus_id=" +
      this.state.id +
      "&user%5Bemail%5D=" +
      (email || event.target.value.replaceAll("@", "%40"));
    this.setState({ author_email_search: email || event.target.value });
    this.apiCall(
      url,
      this.reqOptions("GET", null),
      false,
      this.foundUserCallback
    );
  };

  foundUserCallback = (data) => {
    // console.log('search result callback', data)
    if (this._isMounted) {
      if (data.success) {
        let state = this.state;
        state["author_to_add"] = data.user.id;
        state["author_email_search"] = data.user.email;
        this.setState(state);
      } else {
        this.setState({
          author_to_add: null,
          found_author: data.found_author,
          suggested_emails: data.suggested_emails,
        });
      }
    }
  };

  chooseSuggestedEmail = (email, event) => {
    this.setState({ author_email_search: email });
    this.searchUsers({ email: email }, event);
  };

  addAuthor = (userId, event) => {
    // console.log('called add author')
    const url = api_base + "syllabus_assignments";
    let body = {
      user_id: userId,
      syllabus_id: this.state.id,
      container_id: this.state.container_id,
    };
    this.apiCall(url, this.reqOptions("POST", body), true, (data) => {
      if (this._isMounted) {
        this.setState({ author_email_search: "" });
        this.unfocus();
      }
    });
  };

  // addMainLoToUnit = (unitId, event) => {
  //   const url = api_base + 'main_los_units';
  //   let body = {
  //     syllabus_id: this.state.id,
  //     main_los_unit: {unit_id: unitId, main_lo_id: $('#add-main-lo-to-unit-'+unitId).val()},
  //     container_id: this.state.container_id,
  //   }
  //   this.apiCall(url, this.reqOptions('POST', body), true);
  // }

  // addReadingToMainLo = (loId, event) => {
  //   const url = api_base + 'main_los_readings';
  //   let body = {
  //     syllabus_id: this.state.id,
  //     main_los_reading: {main_lo_id: loId, syl_req_reading_id: $('#add-reading-to-unit-'+loId).val()},
  //     container_id: this.state.container_id,
  //   }
  //   this.apiCall(url, this.reqOptions('POST', body), true);
  // }

  deactivateSyllabus = () => {
    let state = this.state;
    const url = api_base + "syllabi/" + state.id;
    console.log("deactivateSyllabus api url: " + url);
    const body = { syllabus: { active: false } };
    // ready to send deactivate api call to deactivate this syllabus entry
    if (confirm("Are you sure you want to delete " + state.course_name + "?")) {
      if (log_to_console) {
        console.log("Confirmed deactivate syllabus!!!");
      }
      this.apiCall(
        url,
        this.reqOptions("PATCH", body),
        false /** Don't do the default state update for this container **/,
        null // data => this.setState({units: data}) /** custom state update **/
      )
        .then((data) => {
          if (log_to_console) {
            console.log("IN CALLBACK!!! " + url);
          }
          // let s = this.state
          // //remove the deactivated syllabus from the state
          // s.syllabi.splice(idx, 1)
          // this.setState(s);
        })
        .catch((err) => console.log);
    }
  };

  reqOptions = (method, body) => {
    return {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: body ? JSON.stringify(body) : null,
    };
  };

  apiCall = (url, reqOptions, updateState, next) => {
    const sylContainer = this;
    if (log_to_console) {
      console.log("trying to send api request with url:", url);
      console.log("trying to send api request with body:", reqOptions.body);
      console.log("id of syllabus stored in state: ", this.state.id);
      console.log("updateState: ", updateState);
      console.log("next: ", next);
    }
    try {
      fetch(url, reqOptions).then((res) => {
        if (res.status === 401) {
          // alert('Unauthorized. Either your session has expired or you are not authorized to perform this action. Please try logging out and logging in again.')
          if (
            confirm(
              "Unauthorized. Either your session has expired or you are not authorized to perform this action. Redirect to login page? \n(Please note: if your session has expired, none of the changes you make to this syllabus will be saved until you log in again.)"
            )
          ) {
            sylContainer.props.history.push("/log_in");
          }
        } else if (res.status >= 400) {
          if (log_to_console) {
            console.log("res.status >= 400 - req result: ", res);
            console.log("current state", sylContainer.state);
            console.log("reqOptions from within promise", reqOptions);
          }
          alert(
            "There was an issue updating the syllabus. Please reload the page and try again."
          );
        } else {
          res.json().then((data) => {
            if (log_to_console) {
              console.log("req result else - status: ", res.status);
              console.log("req result else - data: ", data);
              console.log("current state", sylContainer.state);
              console.log("reqOptions from within promise", reqOptions);
            }
            if (updateState && sylContainer._isMounted) {
              sylContainer.setState(data["syllabus"] ? data["syllabus"] : data);
            }
            if (next) {
              next(data);
            }
          });
        }
      });
    } catch (err) {
      //To Do: handle error
    }
  };

  toggleEditMode = () => {
    this.setState({ edit_mode: !this.state.edit_mode });
  };

  /**
   * Unfocus any input elements currently in focus.
   **/
  unfocus = () => {
    this.setState({ key_in_focus: null, suggested_emails: [] });
  };

  /**
   * Give user the edit/input view of the element with this key.
   **/
  focus = (key, e) => {
    if (this.canFocus(key)) {
      if (e) e.stopPropagation();
      const foundElem = !!document.getElementById(key);
      if (this.state.key_in_focus != key && foundElem) {
        this.setState({ key_in_focus: key });
      }
    }
  };

  canFocus = (key) => {
    const hasPermission =
      this.state.permissions["update"] ||
      (this.state.permissions["assign_authors"] && key === "addauth");
    return hasPermission && this.state.edit_mode && this.state.connected;
  };

  subscribe = () => {
    const sylContainer = this;
    const sylConsumer = this.state.cable_consumer || consumer;
    const subscription = sylConsumer.subscriptions.create(
      {
        channel: "SyllabusChannel",
        syllabus: sylContainer.state.id,
      },
      {
        connected() {
          // console.log('subscribed to syllabus channel')
          sylContainer
            .fetchSyllabus()
            .then(() => {
              let doAlert = sylContainer.state.data_ready;
              //If reconnecting after a lost subscription, keep edit mode as it is
              //currently stored in the container state. ELSE if connecting for the first
              //time, default to edit_mode = true if the user has permission to update
              //this syllabus.
              //NOTE: We don't want to enter edit mode by default anymore.
              // let editModeVal = sylContainer.state.data_ready ? sylContainer.state.edit_mode : (sylContainer.state.permissions['update'] || sylContainer.state.permissions['assign_authors']);
              if (sylContainer._isMounted) {
                sylContainer.setState({
                  connected: true,
                  data_ready: true,
                  // edit_mode: editModeVal,
                });
              }
              if (doAlert) {
                alert("Reconnected to the Syllabus App!");
              }
            })
            .catch((err) => {
              if (sylContainer._isMounted) {
                this.setState({ display_error: true });
              }
            });
        },
        received(data) {
          if (this.shouldUpdate(data)) {
            // console.log('should update from subscrpition');
            // console.log(sylContainer.state.userId);
            // console.log(sylContainer.state.container_id);
            // console.log(data)
            const changed_permissions_user = !!data.syllabus
              ? data.syllabus.changed_permissions_user_id
              : null;
            if (sylContainer._isMounted) {
              if (data.syllabus) {
                data.syllabus["lastUpdateType"] = "syllabus";
                data.syllabus["updateTime"] = Date.now();
                sylContainer.setState(data.syllabus);
              } else {
                sylContainer.setState({
                  lastUpdateType: data["update_type"],
                  updateTime: Date.now(),
                });
              }
            }
            /** update user permissions if the syllabus teams were updated **/
            if (
              sylContainer._isMounted &&
              changed_permissions_user == sylContainer.state.userId
            ) {
              sylContainer.setState(data.syllabus.changed_permissions);
            }
          }
        },
        shouldUpdate(data) {
          return (
            (data.syllabus || data.update_type) &&
            (data.updated_by_id !== sylContainer.state.userId ||
              data.container_id != sylContainer.state.container_id)
          );
        },
        disconnected() {
          if (sylContainer._isMounted) {
            sylContainer.setState({ connected: false, key_in_focus: null });
            let alertText =
              "Warning: Lost connection to the Syllabus App!" +
              (sylContainer.state.edit_mode
                ? " Switching to read-only mode."
                : "");
            alert(alertText);
          }
        },
      }
    ); /**create subscription function call**/

    /**
     * Let component keep track of subscription in order to
     * unsubscribe when componentWillUnmount
     **/
    if (this._isMounted) {
      this.setState({
        subscription: subscription,
        cable_consumer: sylConsumer,
      });
    } else {
      sylConsumer.disconnect();
    }
  };

  render() {
    let {
      al_coursework,
      assmt_matrix_points,
      assmt_type_options,
      author_to_add,
      author_email_search,
      connected,
      container_id,
      core_issue,
      credit_hours,
      course_code_a,
      course_description_locales,
      course_name,
      plc_link,
      data_ready,
      display_error,
      edit_mode,
      eng_routine_lookup_id,
      found_author,
      grand_challenge_options,
      id,
      key_in_focus,
      lab_field,
      lastUpdateType,
      rr_options,
      main_los,
      permissions,
      progress_a,
      subject_lookup_id,
      subject_options,
      suggested_emails,
      syl_grand_challenges,
      syl_matrix_assmts,
      updateTime,
      unit_child_options,
      units,
      users,
      weeks,
    } = this.state;

    const progACounter = new Counter(0);
    const canEditProgress = connected && edit_mode && permissions["update"];
    const canViewProgress = permissions["update"];
    const canEditContent = connected && edit_mode && permissions["update"];
    const core_concepts_str =
      `${course_code_a[0]}`.toLowerCase() === "t"
        ? "Disciplinary Core Concepts"
        : "Core Concepts";

    // const core_concepts_str = `${course_code_a[0]}`.toLowerCase() === "t" ? "Disciplinary Core Concepts" : "Core Concepts";
    const teams = this.mapUsersToTeam(users);
    // const readingsById = syl_req_readings.reduce((acc, r) => {acc[r.id] = r; return acc;}, {});

    const accessDeniedHtml = (
      <div role="alert" className="card inner-buffer alert alert-danger">
        Access Denied: your session has expired or you are not authorized to
        view this Syllabus. Try logging out and logging in again.
      </div>
    );

    const editBtn = (
      <div style={{ marginTop: 10, height: 44 }}>
        <button
          className="btn btn-primary ml-3 mt-1"
          onClick={this.toggleEditMode}
        >
          {edit_mode ? "Leave Edit Mode" : "Enter Edit Mode"}
        </button>
      </div>
    );

    const instructorSection = false ? (
      <section id="instructor-info" className="top-buffer">
        <h2>Instructor Information</h2>
        <InstructorInfo user={null} />
      </section>
    ) : null;

    const devTeams = edit_mode ? (
      <section id="syllabus-dev-teams" className="top-buffer">
        <h2 className="d-flex flex-row justify-content-between">
          Syllabus Development Teams
        </h2>
        <AuthorsTable
          teamName="US Team"
          authors={teams["usuniv"]}
          editMode={connected && edit_mode && permissions["assign_authors"]}
          removeAuthor={this.removeItem}
        />
        <AuthorsTable
          teamName="Egyptian Team"
          authors={teams["eguniv"]}
          editMode={connected && edit_mode && permissions["assign_authors"]}
          removeAuthor={this.removeItem}
        />
        {permissions["assign_authors"] && edit_mode ? (
          <AddTeamMember
            focusKey={key_in_focus}
            focus={this.focus}
            handleChange={this.searchUsers}
            submit={this.addAuthor}
            userId={author_to_add}
            search={author_email_search}
            suggestedEmails={suggested_emails}
            foundAuthor={found_author}
            chooseSuggestedEmail={this.chooseSuggestedEmail}
          />
        ) : (
          ""
        )}
      </section>
    ) : (
      ""
    );

    const syllabusHtml = (
      <div onClick={this.unfocus}>
        <div className="d-flex flex-row justify-content-center">
          <img
            src={logoUsaid}
            className="rounded float-left"
            style={{ width: 200, height: 78 }}
            alt="usaid"
          />
          <h1 style={{ marginTop: 10 }}>Course Syllabus</h1>
          {connected && (permissions["update"] || permissions["assign_authors"])
            ? editBtn
            : ""}
        </div>
        <div className="container">
          <ProgressBar progressA={progress_a} />
          <h4 className="d-flex flex-row justify-content-left">
            <StatusBox
              progressA={progress_a}
              index={progACounter.count()}
              sectionName="Course Name, Code, Credit Hours, Teaching hours, and Author Teams Complete? "
              editMode={connected && edit_mode && permissions["update"]}
              handleChange={this.toggleProgressA}
            />
          </h4>

          <section id="course-info">
            <CourseCode
              course_code_a={course_code_a}
              subject={subject_lookup_id}
              subjectOpts={subject_options}
              focusKey={key_in_focus}
              focus={this.focus}
              handleSubjChange={this.updateSyllabus}
              handleCodeChange={this.updateCourseCode}
            />
            <CourseName
              courseName={course_name}
              focusKey={key_in_focus}
              focus={this.focus}
              handleChange={this.updateSyllabus}
            />
            <CoursePlc
              editMode={canEditContent}
              plcLink={plc_link}
              focus={this.focus}
              focusKey={key_in_focus}
              handleChange={this.updateSyllabus}
            />
            <CreditHours
              creditHours={credit_hours}
              focusKey={key_in_focus}
              handleChange={this.updateSyllabus}
              focus={this.focus}
            />
            <TeachHrs
              creditHrs={credit_hours}
              activeLearningHrs={al_coursework}
              labHrs={lab_field}
              handleChange={this.updateSyllabus}
              focus={this.focus}
              focusKey={key_in_focus}
            />
          </section>

          {instructorSection}

          <hr />

          <section id="course-description" className="top-buffer">
            <h4>Course Description</h4>
            <h5 className="d-flex flex-row justify-content-left">
              <StatusBox
                progressA={progress_a}
                index={progACounter.count()}
                sectionName="Course Descriptions Complete? "
                editMode={connected && edit_mode && permissions["update"]}
                handleChange={this.toggleProgressA}
              />
            </h5>
            <CourseDesc
              locale="en"
              text={course_description_locales.en}
              focusKey={key_in_focus}
              focus={this.focus}
              handleChange={this.updateSyllabus}
              dataReady={data_ready}
            />
            <CourseDesc
              locale="ar_EG"
              text={course_description_locales.ar_EG}
              focusKey={key_in_focus}
              focus={this.focus}
              handleChange={this.updateSyllabus}
              dataReady={data_ready}
            />
          </section>

          <section>
            <h4>Core Issue</h4>
            <h5 className="d-flex flex-row justify-content-left">
              <StatusBox
                progressA={progress_a}
                index={progACounter.count()}
                sectionName="Core Issue Complete? "
                editMode={connected && edit_mode && permissions["update"]}
                handleChange={this.toggleProgressA}
              />
            </h5>
            <CoreIssue
              text={core_issue}
              focusKey={key_in_focus}
              focus={this.focus}
              handleChange={this.updateSyllabus}
              dataReady={data_ready}
            />
          </section>

          {
            /**
             * Grand Challenges
             **/
            edit_mode || syl_grand_challenges.length > 0 ? (
              <SectionWithAdd
                id="grand-challenges-section"
                key="grand-challenges-section"
                plType="syl_grand_challenges"
                editMode={canEditProgress}
                addItem={this.addItem}
                progIndex={progACounter.count()}
                showProgress={canViewProgress}
                progressA={progress_a}
                toggleProgressA={this.toggleProgressA}
                sectionName="Grand Challenges"
                hideAddBtn={true}
              >
                <ErrorBoundary>
                  <GrandChallenges
                    options={grand_challenge_options}
                    joins={syl_grand_challenges}
                    editMode={canEditContent}
                    addItem={this.addItem}
                    removeItem={this.removeItem}
                  />
                </ErrorBoundary>
              </SectionWithAdd>
            ) : (
              ""
            )
          }

          <StatefulRichTextSection
            key="big-idea-section"
            sectionName="Big Ideas Explored in This Course"
            syllabusId={id}
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            lastUpdateType={lastUpdateType}
            canViewProgress={true}
            canEditProgress={true}
            api={api_base}
            type="syl_big_idea"
            plType="syl_big_ideas"
            editMode={edit_mode}
            reqOptions={this.reqOptions}
            focus={this.focus}
            focusKey={key_in_focus}
            containerId={container_id}
            updateTime={updateTime}
            defaultText="big idea description..."
          />

          <StatefulConcepts
            key="core-concepts-section"
            api={api_base}
            canEditProgress={true}
            canViewProgress={true}
            containerId={container_id}
            editMode={edit_mode}
            focus={this.focus}
            focusKey={key_in_focus}
            lastUpdateTime={updateTime}
            lastUpdateType={lastUpdateType}
            progIndex={progACounter.count()}
            progressA={progress_a}
            reqOptions={this.reqOptions}
            sectionName={core_concepts_str}
            subjectOpts={subject_options}
            syllabusId={id}
            toggleProgressA={this.toggleProgressA}
          />

          <EnglishRoutine
            key="english-routine-section"
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            containerId={container_id}
            course_code_a={course_code_a}
            editMode={canEditContent}
            eng_routine_lookup_id={eng_routine_lookup_id}
            syllabusId={id}
          />

          <StatefulSimpleSection
            key="main_lo-section"
            sectionName="Course Learning Outcomes"
            childSectionName="Evidence(s) of Learning"
            items={main_los}
            syllabusId={id}
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            lastUpdateType={lastUpdateType}
            canViewProgress={true}
            canEditProgress={true}
            api={api_base}
            type="main_lo"
            plType="main_los"
            childType="evid_of_learning"
            plChildType="evid_of_learnings"
            editMode={edit_mode}
            reqOptions={this.reqOptions}
            focus={this.focus}
            focusKey={key_in_focus}
            containerId={container_id}
            updateTime={updateTime}
            defaultText="Course Learning Outcome description..."
          />

          <StatefulModules
            key="units-section"
            sectionName="Units/Modules"
            units={units}
            syllabusId={id}
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            lastUpdateType={lastUpdateType}
            canViewProgress={true}
            canEditProgress={true}
            api={api_base}
            editMode={edit_mode}
            reqOptions={this.reqOptions}
            focus={this.focus}
            focusKey={key_in_focus}
            containerId={container_id}
            updateTime={updateTime}
            childTypes={unit_child_options}
          />

          {edit_mode || syl_matrix_assmts.length > 0 ? (
            <section
              key="typed-student-assessment"
              id="typed-student-assessment-section"
              className="top-buffer"
            >
              <h4 className="d-flex justify-content-between">
                Basis for Student Evaluation By Type
              </h4>
              <h5 className="d-flex flex-row justify-content-left">
                <StatusBox
                  progressA={progress_a}
                  index={progACounter.count()}
                  sectionName="Matrix for Student Assessment Complete? "
                  editMode={
                    canViewProgress &&
                    connected &&
                    edit_mode &&
                    permissions["update"]
                  }
                  handleChange={this.toggleProgressA}
                />
              </h5>
              <StatefulAssessments
                key="matrix-assmts-section"
                api={api_base}
                assmts={syl_matrix_assmts}
                assmtTypes={assmt_type_options}
                assmtPoints={assmt_matrix_points}
                editMode={canEditContent}
                focusKey={key_in_focus}
                focus={this.focus}
                lastUpdateTime={updateTime}
                lastUpdateType={lastUpdateType}
                containerId={container_id}
                reqOptions={this.reqOptions}
                syllabusId={id}
                units={units}
              />
            </section>
          ) : (
            ""
          )}

          {edit_mode || weeks.length > 0 ? (
            <SectionWithAdd
              id="weekly-plan-section"
              key="weekly-plan-section"
              type="week"
              plType="weeks"
              editMode={canEditProgress}
              showProgress={canViewProgress}
              addItem={this.addItem}
              progressA={progress_a}
              progIndex={progACounter.count()}
              toggleProgressA={this.toggleProgressA}
              sectionName="Weekly Plan"
            >
              <StatefulWeeklyPlan
                editMode={canEditContent}
                units={units}
                mainLos={main_los}
                api={api_base}
                updateTime={updateTime}
                lastUpdateType={lastUpdateType}
                unitChildOptions={unit_child_options}
                reqOptions={this.reqOptions}
                handleChange={this.updateItem}
                removeItem={this.removeItem}
                updateWeeksJoins={this.updateWeeksJoins}
                focus={this.focus}
                focusKey={key_in_focus}
                syllabusId={id}
              />
            </SectionWithAdd>
          ) : (
            ""
          )}

          <StatefulRichTextSection
            key="syl-notes-section"
            sectionName="Teacher Notes"
            syllabusId={id}
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            lastUpdateType={lastUpdateType}
            canViewProgress={true}
            canEditProgress={true}
            api={api_base}
            type="syl_note"
            plType="syl_notes"
            editMode={edit_mode}
            reqOptions={this.reqOptions}
            focus={this.focus}
            focusKey={key_in_focus}
            containerId={container_id}
            updateTime={updateTime}
            defaultText="Notes..."
          />

          {data_ready && rr_options.length >= 2 ? (
            <>
              <StatefulRichTextSection
                key="teaching-resources-section"
                sectionName={rr_options[0].name}
                syllabusId={id}
                progressA={progress_a}
                toggleProgressA={this.toggleProgressA}
                progAIndex={progACounter.count()}
                lastUpdateType={lastUpdateType}
                canViewProgress={true}
                canEditProgress={true}
                api={api_base}
                type="syl_req_reading"
                plType="syl_req_readings"
                typeLookupId={rr_options[0].id}
                editMode={canEditContent}
                reqOptions={this.reqOptions}
                focus={this.focus}
                focusKey={key_in_focus}
                containerId={container_id}
                updateTime={updateTime}
                defaultText={`${rr_options[0].name} description...`}
              />

              <StatefulRichTextSection
                key="class-resources-section"
                sectionName={rr_options[1].name}
                syllabusId={id}
                progressA={progress_a}
                toggleProgressA={this.toggleProgressA}
                progAIndex={progACounter.count()}
                lastUpdateType={lastUpdateType}
                canViewProgress={true}
                canEditProgress={true}
                api={api_base}
                type="syl_req_reading"
                plType="syl_req_readings"
                typeLookupId={rr_options[1].id}
                editMode={canEditContent}
                reqOptions={this.reqOptions}
                focus={this.focus}
                focusKey={key_in_focus}
                containerId={container_id}
                updateTime={updateTime}
                defaultText={`${rr_options[1].name} description...`}
              />
            </>
          ) : (
            ""
          )}

          <StatefulRichTextSection
            key="equip-materials-section"
            sectionName="Equipment/Materials/Software"
            syllabusId={id}
            progressA={progress_a}
            toggleProgressA={this.toggleProgressA}
            progAIndex={progACounter.count()}
            lastUpdateType={lastUpdateType}
            canViewProgress={true}
            canEditProgress={true}
            api={api_base}
            type="syl_equip_material"
            plType="syl_equip_materials"
            editMode={edit_mode}
            reqOptions={this.reqOptions}
            focus={this.focus}
            focusKey={key_in_focus}
            containerId={container_id}
            updateTime={updateTime}
            defaultText="Equipment/Materials/Software description..."
          />

          <br />
          <hr />
          {devTeams}
          <br />
          {edit_mode ? (
            <button
              className="btn btn-danger mt-4"
              alt="deactivate"
              type="submit"
              onClick={this.deactivateSyllabus}
            >
              Deactivate course
            </button>
          ) : (
            <span></span>
          )}
          <br />
        </div>
      </div>
    );

    const permittedHtml =
      permissions && permissions["read"] ? syllabusHtml : accessDeniedHtml;

    return data_ready ? permittedHtml : <Spinner />;
  }
}
